import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete } from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details, Translate } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};
`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
const StyledDialog = styled(Dialog)`
  position: relative;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;
const DataGridContainer = styled.div`
  width: 100%;
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile && "20px"};
//   height: 500px;
`;
const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;
const Input = styled.input`
  display: none;
`;
const VisitStartModal = ({ propData, onClose, data, id, distributorId, fetchData, status }) => {
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false)
    const [schoolDetails, setSchoolDetails] = useState([])
    const [distributorDetails, setDistributorDetails] = useState([])
    const [form, setForm] = useState({
        tagColleague: "" || propData?.tag_user1 ? true : false,
        partyType: "" || propData?.partyType,
        ownerId: "" || propData?.ownerId,
        partyId: "" || propData?.partyId,
        visitEntryType: "" || propData?.visitEntryType,
        tagUser: "" || propData?.tag_user1,
        superwisor: "" || propData?.superwisor,
        // remark: "" || propData?.remarks,
        startRemark: "" || propData?.startRemark,
    })
    const [errors, setErrors] = useState({});
    const [employee, setEmployee] = useState([])
    const [assignedEmp, setAssignedEmp] = useState(null)
    const [partyType, setPartyType] = useState()
    const [party, setParty] = useState([])
    const [selectParty, setSelectParty] = useState(null)
    const [date, setDate] = useState()
    const [fetchPartyTypes, setfetchedPartyType] = useState(0)
    const [statusWork, setStatusWork] = useState([])
    const [series, setSeries] = useState([])
    const [selectedSeries, setSelectedSeries] = useState(null)
    const [selectedSeries1, setSelectedSeries1] = useState(null)
    const [workDone, setWorkDone] = useState([])
    const [nextStep, setNextStep] = useState([])
    const [feedback, setFeedback] = useState([])
    const [visitType, setVisitType] = useState([])
    const [visitTypeCheck, setVisitTypeCheck] = useState(false)
    const [partyTypeCheck, setPartyTypeCheck] = useState(false)
    const [colleagueUser, setColleagueUser] = useState([])
    const [filteredColleagueUser, setFilteredColleagueUser] = useState([])
    const [visitOutcomes, setVisitOutcomes] = useState([]);
    const [startVisit, setStartVisit] = useState(null);
    const [startMeeting, setStartMeeting] = useState(null);
    const [endVisit, setEndVisit] = useState(null);
    const [endMeeting, setEndMeeting] = useState(null);
    const [startVisitP, setStartVisitP] = useState(null);
    const [startMeetingP, setStartMeetingP] = useState(null);
    const [endVisitP, setEndVisitP] = useState(null);
    const [endMeetingP, setEndMeetingP] = useState(null);
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [colleagueRm, setColleagueRm] = useState("")
    const [colleagueRsm, setColleagueRsm] = useState("")
    const [colleagueAsm, setColleagueAsm] = useState("")
    const [colleagueRms, setColleagueRms] = useState([])
    const [colleagueRsms, setColleagueRsms] = useState([])
    const [colleagueAsms, setColleagueAsms] = useState([])
    useEffect(() => {
        fetchPartyType()
        fetchEmployees()
        getVisitType()
    }, [])


    useEffect(() => {
        // if(tabValue===1){
        //   fetchProduct(plantCode,distributorId)
        // }
        if (!status) {
            fetchColleague(propData?.ownerId)
            if (propData?.partyType === "1") {
                setfetchedPartyType(1)
                getSchool({
                    ownerId: propData?.ownerId
                })
            } else {
                getDistributor({
                    ownerId: propData?.ownerId
                })
                setfetchedPartyType(2)
            }
        }
    }, [])

    useEffect(() => {
        if (distributorDetails[0]) {
            setForm(prev => ({
                ...prev,
            }));
        }
    }, [distributorDetails]);

    useEffect(() => {
        if (schoolDetails[0]) {
            setForm(prev => ({
                ...prev,
            }));
        }
    }, [schoolDetails]);

    useEffect(() => {
        if (form?.tagColleague) {
            setForm(prev => ({
                ...prev,
                tagColleague: true,
                tagUser: propData?.tag_user1,
                superwisor: propData?.superwisor
            }));
            // if (propData?.colleagueRsm) setColleagueRsm(propData?.colleagueRsm);
            // if (propData?.superwisor) setColleagueAsm(propData?.superwisor);
            // if (propData?.tag_user1) setColleagueRm(propData?.tag_user1);
            setColleagueAsm(propData?.superwisor || "");
            setColleagueRm(propData?.tag_user1 || "");
        }
        else {
            setForm(prev => ({
                ...prev,
                tagUser: "",
                superwisor: ""
            }));
            setColleagueAsm("")
            setColleagueRm("")
            setColleagueRsm("")
        }
    }, [form?.tagColleague, propData])

    const handleEndVisitChange = (newValue) => {
        setEndVisit(newValue);
        setForm((prev) => ({
            ...prev,
            endTime: newValue
        }));
    };

    const handleEndMeetingChange = (newValue) => {
        setEndMeeting(newValue);
        setForm((prev) => ({
            ...prev,
            endMeetingTime: newValue
        }));
    };

    const getSeriesCategory = async () => {
        let results = await window.Platform.database.getSeriesCategory();
        setSeries(results.data)
    }
    const fetchColleague = async (data) => {
        let results = await window.Platform.database.getManager({ ownerId: data });
        setColleagueUser(results.data)
    }

    const getWorkDone = async () => {
        let results = await window.Platform.database.getWorkDone();
        setWorkDone(results.data)
    }

    const getNextStep = async () => {
        let results = await window.Platform.database.getNextStep();
        setNextStep(results.data)
    }

    const getFeedback = async () => {
        let results = await window.Platform.database.getFeedback();
        setFeedback(results.data)
    }
    const getVisitType = async () => {
        let results = await window.Platform.database.getRouteVisitType();
        setVisitType(results.data)
    }

    const getVisitOutcomes = async () => {
        try {
            setLoading(true);
            let results = await window.Platform.database.getVisitOutcomes();
            setVisitOutcomes(results.data);
            // const jsonArrayWithId = results?.data?.map((obj, index) => ({
            //   ...obj,
            //   id: index + 1,
            // }));
            // setAccessChanges(jsonArrayWithId);
            setLoading(false);
        } catch (error) {
            window.NotificationUtils.showError("Error Fetching Data");
            setLoading(false);
        }
    }
    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const changeHandler = (fieldName, value) => {
        if (fieldName === "tentativeAmount" || fieldName === "noOfBook") {
            const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
            setForm((prevForm) => ({ ...prevForm, [fieldName]: sanitizedValue }))
        }
        else {
            console.log(value)
            setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
        }
    };

    // const changeHandler = (fieldName, value) => {
    //    if(fieldName==="tentativeAmount"||fieldName==="noOfBook"){
    //   const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
    //   setForm((prevForm) => ({ ...prevForm, [fieldName]: sanitizedValue }))
    // }
    // else{
    //   setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
    // }
    // };

    const getDistributor = async (data) => {
        setLoading(true)
        setParty([])
        const results = await window.Platform.database.getAllDistri(data);
        setParty(results.data)
        setSelectParty(null)
        if (!status) {
            const filteredEmp = results?.data?.filter((data) => data.distributorID === propData.partyId)
            setSelectParty(filteredEmp[0])
        }
        setLoading(false)
    }

    const partyTypeHandler = (data) => {
        if (data === "cQpLw8vwZf") {
            changeHandler("partyType", "1")
            setfetchedPartyType(1)
            getSchool({ ownerId: form?.ownerId })
            setPartyTypeCheck(false)
        } else if (data === "P6E9TGXewd") {
            changeHandler("partyType", "0")
            setfetchedPartyType(2)
            setPartyTypeCheck(false)
            getDistributor({ ownerId: form?.ownerId })
        } else if (data === "GXjqJfCSLp") {
            setPartyTypeCheck(true)
        } else {
            setPartyTypeCheck(true)
        }
        // changeHandler("partyType", data)
    }
    const visitTypeHandler = (data) => {
        if (data === "NKlytW4260") {
            setVisitTypeCheck(true)
        } else {
            setVisitTypeCheck(false)
        }
        changeHandler("visitEntryType", data)
    }
    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                // setColleagueAsms(results?.data)
                setRms(results?.data1)
                // setColleagueRms(results?.data1)
                setEmployee(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
                // setColleagueRms(results?.data)
                setEmployee(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                // setColleagueAsm("")
                // setColleagueRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                // setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
                setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
                // setColleagueAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                // setColleagueRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                // setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
                setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }
    }

    async function getUsersColleague(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setColleagueAsms(results?.data)
                setColleagueRms(results?.data1)
                setEmployee(results?.data1)
            }
            if (role == 'asm') {
                setColleagueRms(results?.data)
                setEmployee(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setColleagueAsm("")
                setColleagueRm("")
                setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
                setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
                setColleagueAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setColleagueRm("")
                setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
                setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }
    }

    useEffect(() => {
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
            getAllUsersColleague()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setEmployee(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    async function getAllUsersColleague() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setEmployee(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setColleagueRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setColleagueRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setColleagueAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    const getSchoolById = async (schoolId) => {
        setLoading(true);
        const result = await window.Platform.database.getSchoolDataBasedOnId({ schoolId: schoolId });
        setSchoolDetails(result.data)
        setLoading(false);
    };

    const getDistributorById = async (distributorID) => {
        setLoading(true);
        const result = await window.Platform.database.getDistributorByID({ id: distributorID });
        setDistributorDetails(result.data)
        setLoading(false);
    };

    const renderContent1 = () => {
        return (
            <div style={{ maxHeight: "510px", height: "505px", overflowY: "auto" }}>
                <Stack direction={"row"} spacing={2} padding={2}>
                    {userData?.role.includes('admin') && <FormControl fullWidth>
                        <InputLabel id="select-label" >Select HO:</InputLabel>
                        <Select
                            labelId="select-label"
                            id="select"
                            value={rsm}
                            onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
                            label="Select HO:"
                        >
                            <MenuItem value="">All</MenuItem>
                            {rsms?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {/* {option.name} */}
                                    {option.name} - {option.username}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                    {userData?.role != 'asm' && <FormControl fullWidth>
                        <InputLabel id="select-label" >Select ARM:</InputLabel>
                        <Select
                            labelId="select-label"
                            id="select"
                            value={asm}
                            onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
                            label="Select ARM:"
                        >
                            <MenuItem value="">All</MenuItem>
                            {asms?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {/* {option.name} */}
                                    {option.name} - {option.username}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
                    <FormControl fullWidth>
                        <InputLabel id="select-label" required error={errors.ownerId ? true : false}>Select RM</InputLabel>
                        <Select
                            labelId="select-label"
                            id="select"
                            value={form?.ownerId || rm}
                            onChange={async (e) => {
                                const selectedRmId = e.target.value;
                                setRm(selectedRmId);
                                changeHandler("ownerId", selectedRmId);
                                // Get users for this RM
                                // let results = await window.Platform.database.getUsersBasedOnManager({ userId: selectedRmId });
                                // Find selected RM's cluster
                                const selectedRM = rms?.find(user => String(user.id) === String(selectedRmId));
                                const rmCluster = selectedRM?.cluster;
                                // Filter users whose cluster matches selected RM's cluster (excluding RM)
                                console.log(selectedRmId, "selectedRmId", rmCluster)
                                let filteredColleagues = [];
                                if (rmCluster && allUsers) {
                                    filteredColleagues = allUsers.filter(user => String(user.id) !== String(selectedRmId) && user.cluster === rmCluster);
                                }
                                setFilteredColleagueUser(filteredColleagues);
                            }}
                            label="Select RM:"
                            required error={errors.ownerId ? true : false}
                        >{console.log(filteredColleagueUser, "sdsdsdsdssdsd")}
                            <MenuItem value="">All</MenuItem>
                            {rms?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name} - {option.username}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction={"row"} spacing={2} padding={2}>
                    <FormControl fullWidth>
                        <InputLabel id="select-label" required error={errors.visitType ? true : false}>Visit Type</InputLabel>
                        <Select
                            labelId="select-label"
                            id="select"
                            value={form.visitEntryType}
                            onChange={(e) => visitTypeHandler(e.target.value)}
                            label="Visit Type"
                            required
                            error={errors.visitType ? true : false}
                        >
                            {visitType?.map((option) => (
                                <MenuItem key={option.routeVisitTypeID} value={option.routeVisitTypeID}>
                                    {option.routeVisitType}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel id="select-label" required error={errors.partyType ? true : false}>Party Type</InputLabel>
                        <Select
                            labelId="select-label"
                            id="select"
                            value={form.partyType == 0 ? "P6E9TGXewd" : form.partyType == 1 ? "cQpLw8vwZf" : ""}
                            onChange={(e) => partyTypeHandler(e.target.value)}
                            label="Party Type"
                            required
                            error={errors.partyType ? true : false}
                        >
                            {partyType?.map((option) => (
                                <MenuItem key={option.partyTypeId} value={option.partyTypeId}>
                                    {option.type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction={"row"} spacing={2} padding={2}>
                    {fetchPartyTypes === 1 ?
                        <Autocomplete
                            options={party}
                            getOptionLabel={(option) => option.schoolId && option.schoolName ? `${option.schoolId} - ${option.schoolName}` : option.schoolName || option.schoolId || ""}
                            getOptionValue={(option) => option?.schoolId || ''}
                            style={{ width: "100%" }}
                            value={selectParty}
                            disabled={fetchPartyTypes != 1}
                            noOptionsText={loading ? "Loading..." : "No option"}
                            onChange={async (event, value) => {
                                changeHandler("partyId", value?.schoolId)
                                setSelectParty(value)
                                if (value?.schoolId) {
                                    await getSchoolById(value.schoolId);
                                }
                            }}
                            onInputChange={(e, value) => {
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={"Select Party"}
                                    required
                                    variant="outlined"
                                    error={errors.party ? true : false}
                                />
                            )} />
                        :
                        <Autocomplete
                            options={party}
                            getOptionLabel={(option) => option.distributorID && option.DistributorName ? `${option.distributorID} - ${option.DistributorName}` : option.DistributorName || option.distributorID || ""}
                            // getOptionLabel={(option) => `${option?.DistributorName}`}
                            getOptionValue={(option) => option?.schoolId || ''}
                            style={{ width: "100%" }}
                            value={selectParty}
                            disabled={fetchPartyTypes != 2}
                            noOptionsText={loading ? "Loading..." : "No option"}
                            onChange={async (event, value) => {
                                changeHandler("partyId", value?.distributorID)
                                setSelectParty(value)
                                if (value?.distributorID) {
                                    await getDistributorById(value.distributorID);
                                }
                            }}
                            onInputChange={(e, value) => {
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={"Select Party"}
                                    required
                                    variant="outlined"
                                    error={errors.party ? true : false}
                                />
                            )} />}
                    <TextField label="Visit Start Remarks" value={form?.startRemark} type="text" fullWidth onChange={(e) => changeHandler("startRemark", e.target.value)} required error={errors.startRemark ? true : false} />
                    {/* <TextField label="Remarks" value={form?.remark} type="text" fullWidth onChange={(e) => changeHandler("remark", e.target.value)} required error={errors.remark ? true : false} /> */}
                </Stack>
                {/* <Stack direction={"row"} spacing={2} padding={2}>
                    <TextField label="Visit Start Remarks" value={form?.startRemark} type="text" fullWidth onChange={(e) => changeHandler("startRemark", e.target.value)} required error={errors.startRemark ? true : false} />
                    </Stack> */}
                <Stack>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={form?.tagColleague || false}
                                onChange={(e) => changeHandler("tagColleague", e.target.checked)}
                            />
                        }
                        label="Tag Colleague"
                        style={{ marginLeft: 16 }}
                    />
                </Stack>
                {form?.tagColleague &&
                    <Stack direction={"row"} spacing={2} padding={2}>
                        <FormControl fullWidth>
                            <InputLabel id="select-label">Tag Colleague (Cluster Match)</InputLabel>
                            <Select
                                labelId="select-label"
                                id="select"
                                value={colleagueRm}
                                onChange={(e) => { setColleagueRm(e.target.value); changeHandler("tagUser", e.target.value) }}
                                label="Tag Colleague (Cluster Match)"
                            >
                                <MenuItem value="">All</MenuItem>
                                {filteredColleagueUser?.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <Button variant="contained" disabled={loading} fullWidth onClick={() => onsubmit(form)}>Submit</Button>
                </div>
            </div>
        )
    }

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            setLoading(true)
            const results = await window.Platform.database.getUsersForWork();
            // setEmployee(results.data)
            setAssignedEmp(null)
            if (!status) {
                const filteredEmp = results?.data?.filter((data) => data.id === propData.ownerId)
                setAssignedEmp(filteredEmp[0])
            setLoading(false)
            }
            else{
            setLoading(false)
            }
        }
        catch (e) {
            setLoading(false)
            console.log(e)
        }

    }

    const validateForm = (data) => {
        const errors = {};
        // if (!data?.remark?.trim()) {
        //     errors.remark = "Remark is required";
        // }
        if (!data?.startRemark?.trim()) {
            errors.startRemark = "Visit Start Remark is required";
        }
        if (!data.ownerId) {
            errors.ownerId = "RM is required";
        }
        if (!data.partyId?.trim()) {
            errors.party = "Party is required";
        }
        return errors;
    };

    const onsubmit = async (data) => {
        setLoading(true);
        try {
            const errors = validateForm(data);
            setErrors(errors);
            // let hasError = false;
            // let newErrors = { ...errors };
            // if (!data.startRemark || data.startRemark.trim() === "") {
            //     newErrors.startRemark = true;
            //     hasError = true;
            //     setLoading(false);
            // } else {
            //     newErrors.startRemark = false;
            //     setLoading(false);
            // }
            // setErrors(newErrors);
            // if (hasError) return;
            if (Object.keys(errors).length === 0) {
                // setLoading(true);
                // const payload = { data }
                const payload = {
                    ownerId: data.ownerId,
                    partyType: data.partyType,
                    partyId: data.partyId,
                    visitEntryType: data.visitEntryType,
                    tag_user: data.tagUser,
                    // superwisor: data.superwisor,
                    extra: data.startRemark
                };
                const results = await window.Platform.database.startVisit(payload);
                if (results.status) {
                    window.NotificationUtils.showError(results?.message);
                    setLoading(false);
                } else {
                    window.NotificationUtils.showSuccess(results?.message);
                    setLoading(false);
                    onClose();
                    fetchData();
                }
            } else {
                window.NotificationUtils.showError("Please fill the form correctly.");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const fetchPartyType = async (details) => {
        try {
            setLoading(true)
            let results = await window.Platform.database.fetchPartyType(details);
            setPartyType(results.data)
            setLoading(false)
        }
        catch (err) {
            console.log(err);
            setLoading(false)
        }
    }

    const getSchool = async (details) => {
        try {
            setLoading(true)
            setParty([])
            const results = await window.Platform.database.getAllSchool(details);
            setParty(results.data)
            setSelectParty(null)
            if (!status) {
                const filteredEmp = results?.data?.filter((data) => String(data.schoolId) == String(propData.partyId))
                setSelectParty(filteredEmp[0])
            }
            setLoading(false)
        }
        catch (err) {
            console.log(err);
            setLoading(false)
        }
    }
    return (
        <Dialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} >
            {loading && <OpaqueLoading />}
            <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
                <Typography variant={isMobile ? "h6" : "h5"}>
                    Start Visit
                    <Tooltip title="Order Id">
                        {id}
                    </Tooltip>
                </Typography>
                <IconButton onClick={onClose} >
                    <CloseOutlined />
                </IconButton>
            </ModalHeaderContainer>
            <TableContainer>
                <TabsContainer>
                    <StyledTabs
                        variant="fullWidth"
                        value={tabValue}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Start Visit " />
                    </StyledTabs>
                    {renderContent1()}
                </TabsContainer>
            </TableContainer>
        </Dialog>
    );
};

export default VisitStartModal;